import { componentDefinitions, noetivraAvailabilityLabel } from './siteContent'

/** Three connected foundations, in canonical order: SKP, HCF, Noetivra. */
export const foundations = [
  {
    id: 'semantic-knowledge',
    tag: 'Knowledge infrastructure',
    title: componentDefinitions.skp.name,
    body: componentDefinitions.skp.definition,
    example:
      'A research organization could connect studies, methods, populations and findings, then trace any approved relationship back to the passage that supports it.',
    link: '/semantic-knowledge',
    linkLabel: 'Explore SKP',
  },
  {
    id: 'human-capability',
    tag: 'Assessment & development framework · CJI · NCJI',
    title: componentDefinitions.hcf.name,
    body: componentDefinitions.hcf.definition,
    example: '',
    link: '/human-capability',
    linkLabel: 'Explore the framework',
  },
  {
    id: 'noetivra',
    tag: noetivraAvailabilityLabel,
    title: componentDefinitions.noetivra.name,
    body: componentDefinitions.noetivra.definition,
    example: '',
    link: '/noetivra',
    linkLabel: 'Explore Noetivra',
  },
]

/** CJI and NCJI, shown within the HCF foundation. */
export const humanCapabilityProducts = [
  {
    acronym: 'CJI',
    name: componentDefinitions.cji.name,
    body: componentDefinitions.cji.definition,
    link: '/cji',
  },
  {
    acronym: 'NCJI',
    name: componentDefinitions.ncji.name,
    body: componentDefinitions.ncji.definition,
    link: '/ncji',
  },
]

/** Three concrete examples of knowledge becoming action. */
export const actionExamples = [
  {
    who: 'A researcher',
    title: 'Traces a finding to its source',
    body: 'Opens an approved relationship in the knowledge map, reads the exact passage behind it and sees the limits the reviewer recorded.',
    domain: 'research' as const,
  },
  {
    who: 'A learner',
    title: 'Reviews feedback and completes practice',
    body: 'Reads criterion-by-criterion feedback on a task, completes a focused activity with a reflection and returns to a changed scenario.',
    domain: 'education' as const,
  },
  {
    who: 'An institution',
    title: 'Reviews a support request and records its decision',
    body: 'Checks the request and any additional information, then records a decision with its reason so the person can follow what happened.',
    domain: 'government' as const,
  },
]

/** What is available now and what comes next. */
export const availabilityStages = [
  {
    status: 'Available now',
    title: 'Interactive demonstrations',
    body: 'Seven browser-based demos using fictional records, including source-to-reviewed-knowledge, development and reassessment workflows, and a separately scoped clinical documentation review.',
  },
  {
    status: 'In development',
    title: 'Production engineering and integration',
    body: 'Production identity and organization membership, role-scoped server records and bounded integrations with SKP and relevant operational services.',
  },
  {
    status: 'Through pilots',
    title: 'Assessment validation',
    body: 'Define intended uses, then test reliability, validity, real-world usefulness and lasting change before any assessment is relied on.',
  },
]
